module.exports = __webpack_public_path__ + "static/media/logo.8d00a848.svg";